// extracted by mini-css-extract-plugin
module.exports = {"bulk_footer":"styles_bulk_footer__1iVUG"};